import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { TextField } from '@mui/material';
import { IPets } from 'app/models/Placement/PlacementMods';
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditPreferencePetsRows, selectExpandedModsDialog } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findIndex, findRow } from '../AdultGridComponents/AdultNameCell';
import { getDisplayValue } from '../utils';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const PetDetailsCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <PetDetails cellParams={cellParams} />
    </>
  );
};

const PetDetails = React.memo(function PetDetails(cellParams: GridCellProps) {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  const isExpanded = useSelector(selectExpandedModsDialog);
  const editPreferencePetsRequests = useSelector(selectEditPreferencePetsRows);

  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferencePetsRequests);
  const details = rowData?.details;
  const [petDetail, setPetDetail] = useState(details === '--' ? null : details);

  const setDetailForPetGridEdit = data => {
    let newRows = editPreferencePetsRequests.slice(0);
    let petsGridEditRow = findRow(editPreferencePetsRequests, RowId);

    let updatedDetail = {} as IPets;
    updatedDetail = {
      ...petsGridEditRow,
      details: data.trim() ? data : '',
    };
    let editDetailIndex = findIndex(editPreferencePetsRequests, RowId);
    newRows[editDetailIndex] = updatedDetail;
    dispatch(placementModsAction.setEditPetsRows(newRows));
  };

  return (
    <>
      <Controller
        name={`petsGrid${RowId}.detail`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: isExpanded ? '688px' : '110px',
            }}
            value={petDetail}
            inputProps={{ maxLength: 255 }}
            onBlur={e => {
              setDetailForPetGridEdit(e.target.value);
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                setPetDetail(e.target.value);
                onChange(e.target.value);
              } else {
                setPetDetail('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
